module.exports = __webpack_public_path__ + "img/jeep-1.ca0762fc.png";